import { useSelectedOfferPricing } from 'publisher/pages/offer-page/hooks/useSelectedOfferPricing'
import { usePayment } from 'publisher/store'
import {
  getActivePricePlan,
  getCheckedBump,
  getOfferId,
  getOfferPricing,
  getProduct,
  getProductActiveVariant,
} from 'publisher/store/payment/paymentSelectors'
import { useCalculatedPricePlans } from 'src/publisher/hooks/use-calculated-price-plans'

/**
 * Derives offer pricing values from the Redux store.
 * Safe to call from any component — contains no fetch side effects.
 */
export const useOfferPricing = () => {
  const product = usePayment(getProduct)
  const activePricePlan = usePayment(getActivePricePlan)
  const activeProductVariant = usePayment(getProductActiveVariant)
  const bump = usePayment(getCheckedBump)
  const offerId = usePayment(getOfferId)
  const productBump = bump?.product || null
  const bumpPlan = bump?.pricePlans[0]
  const bumpOfferId = bump?.id

  const { pricePlans } = useCalculatedPricePlans()
  const offerPricing = usePayment(getOfferPricing)

  const selectedOfferPricing = useSelectedOfferPricing({
    selectedProduct: product,
    selectedPricePlan: activePricePlan,
    activeProductVariant,
    offerId,
  })

  const physicalMainOfferPricing = useSelectedOfferPricing({
    selectedProduct: product,
    activeProductVariant,
    offerId,
  })

  const physicalBumpOfferPricing = useSelectedOfferPricing({
    selectedProduct: productBump,
    offerId: bumpOfferId,
  })

  const digitalBumpOfferPricing = useSelectedOfferPricing({
    selectedPricePlan: bumpPlan,
    offerId: bumpOfferId,
  })

  const digitalOfferPricings = offerPricing?.filter(
    calculatedPricing =>
      pricePlans.some(
        pricePlan => pricePlan.id === calculatedPricing.pricePlan,
      ) && calculatedPricing.offerId === offerId,
  )

  return {
    selectedOfferPricing,
    physicalMainOfferPricing,
    physicalBumpOfferPricing,
    digitalOfferPricings,
    digitalBumpOfferPricing,
  }
}
